export default function (/*{ $axios }*/) {
    // $axios.onRequest((config) => {
    //     console.log(`config =>`, config);
    // });
    // $axios.onResponse((response) => {
    //     console.log(`onResponse =>`, response);
    // });
    // $axios.onError((err) => {
    //     console.log(`err =>`, err);
    //     nuxtError({
    //         statusCode: err.response.status,
    //         message: err.message,
    //     });
    //     return Promise.resolve(false);
    // });
    // $axios.onRequestError((err) => {
    //     console.log(`onRequestError =>`, err.response);
    // });
    // $axios.onResponseError((err) => {
    //     console.log(`onResponseError =>`, err.response);
    // });
}
